module.exports = __webpack_public_path__ + "img/map_infield-pavilion.d4a50d81.jpg";